

export const TYPES = {
    ALL: "ALL",
    REQUESTED: "REQUESTED",
    EREEN: "EREEN",
    IRSEN: "IRSEN",
    CONFIRM: "CONFIRM",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
}


export const LEASING_TYPES = {
    N: "N",
    Y: "Y",
}

export const PRODUCT_TYPES = {
    BELEN: "BELEN",
    ZAHIALGA: "ZAHIALGA",
}

export const PROD_TYPES = {
    BELEN_CLOTHS: "BELEN_CLOTHS", // Бэлэн хувцас
    GER: "GER", //Гэр ахуй
    GOYL: "GOYL", // Гоёл  чимэглэл
    HUUHED_HUVTSAS: "HUUHED_HUVTSAS", // Хүүхдийн хувцас
    HUUHED_HEREGSEL: "HUUHED_HEREGSEL", // Хүүхдийн хэрэгсэл
    AYLAL: "AYLAL", // Аялалын хэрэгсэл
    TSAHILGAAN: "TSAHILGAAN", // Цахилгаан хэрэгсэл
}

export const baseUrlLink = "https://songoltbucket.s3.ap-southeast-1.amazonaws.com//upload/image-"